// Dev-only auth bypass. When VITE_DEV_AUTH_BYPASS=true, ProtectedRoute lets
// the app render without a real Cognito token and UserMenu gets a stub user.

export const DEV_AUTH_BYPASS =
  import.meta.env.VITE_DEV_AUTH_BYPASS === 'true' && import.meta.env.DEV;

export const DEV_USER = {
  email: 'virgil.dev@cityelectricsupply.com',
  name: 'Dev User',
  cognito_username: 'dev-user',
};
